import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";

export default function MasterLayout({ children }) {
  /** */

  const location = useLocation();
  const navigate = useNavigate();
  const { changeLocale } = useContext(AppContext);

  useEffect(() => {
    const URLParams = new URLSearchParams(location.search);
    const locale = URLParams.get("locale");
    if (locale) {
      changeLocale(locale);
      URLParams.delete("locale");
      const newSearch = URLParams.toString();
      const newPathname = location.pathname;
      const newUrl = newSearch ? `${newPathname}?${newSearch}` : newPathname;
      navigate(newUrl, { replace: true });
    }
  }, [location.search]);

  // Handle mobile viewport height
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setVH();
    window.addEventListener("resize", setVH);
    window.addEventListener("orientationchange", setVH);

    return () => {
      window.removeEventListener("resize", setVH);
      window.removeEventListener("orientationchange", setVH);
    };
  }, []);

  return <div className="container mx-auto max-w-2xl h-dvh">{children}</div>;
}
